import {POST} from "./api.service.wrapper";
import {apiUrl} from "../utils/constants";

export const SentNotification = async (data) => {
    const response = await POST(apiUrl.push_notifications, data);
    return response;
}